export default {"src":"/_next/static/media/icon-rename.cf3def78.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};